import api from '@/api';

const resource = 'atena/subperfil';

export default {
  getSelectSubPerfil(data) {
    return api.get(`${resource}/select`, {
        params: data,
    });
  },
};